//#region Imports
import { Component, ViewEncapsulation } from '@angular/core';
//#endregion

@Component({
    selector: 'ec-root-app',
    template: '<router-outlet></router-outlet>',
    encapsulation: ViewEncapsulation.None
})
export class MainComponent {}
